module.exports = __webpack_public_path__ + "img/screen10.d71add8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brochure/academic/screen10.png
// module id = 592
// module chunks = 5